module.exports = __webpack_public_path__ + "img/diferencial2.45d3c5ef.png";